import React, { Component, Fragment } from 'react';
import './app.css';
import Layout from "./components/layout/layout-component";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import PrivateRoute from './privateRoute';
import Login from './modules/login/login-container';
import Report from './modules/report/report-container';
import Nav from "./modules/nav/nav-container";
import FullReport from "./modules/full-report-charts/full-report-charts-container";
import Dev from "./modules/dev/dev-container";
import {connect} from "react-redux";
import {loginSuccess} from "./modules/login/login-action-creators";
import ScrollToTop from "./components/scroll-to-top/scroll-to-top-component";
import PieChart from "./components/pie-chart-2/pie-chart-component";
import Reports from "./modules/reports/reports-container";
import AddReport from "./modules/add-report/add-report-container";
import WordVerbatims from "./modules/word-verbatims/word-verbatims-container";
import HBIndexChart from "./modules/hb-index-chart/hb-index-chart-container";
import AddWords from "./modules/add-words/add-words-container";
import ContextMenu from "./modules/context-menu/context-menu-component";
import AddTaxonomy from "./modules/add-taxonomy/add-taxonomy-component";

class App extends Component {

  componentDidMount() {
    this.props.setToken(localStorage.token);
  }

  render() {
    return (
      <Layout>
        <BrowserRouter>
          <ScrollToTop>
              <Fragment>
                <Nav />
                <AddWords />
                <ContextMenu />
                <Switch>
                  <Route exact path="/" render={() => <Redirect to="/reports" />} />
                  <Route path="/login" component={Login}  />
                  <PrivateRoute path="/reports" component={Reports} />
                  <PrivateRoute path="/report/:reportName" component={FullReport} />
                  <PrivateRoute path="/report" component={Report} />
                  <PrivateRoute path="/add-report" component={AddReport} />
                  <PrivateRoute path="/word-verbatims" component={WordVerbatims} />
                  <PrivateRoute path="/hb-index-chart" component={HBIndexChart} />
                  <PrivateRoute path="/add-taxonomy" component={AddTaxonomy} />
                  <PrivateRoute path="/dev" component={Dev} />
                  <Route path="/play" component={PieChart} />
                  <Route render={() => <Redirect to="/" /> } />
                </Switch>
              </Fragment>
          </ScrollToTop>
        </BrowserRouter>
      </Layout>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  setToken: token => dispatch(loginSuccess(token))
});

export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/app.js